import React, {useEffect, useState} from "react";

const FraudNetScript = ({
  s,f
}) => {

    const [paramsApplied, setParamsApplied] = useState(false)

    useEffect(() => {
    //if payment is piq card, load their script

      if(s !== "" && f !== "") {
          const script = document.createElement("script");
          script.type = 'application/json'
          script.setAttribute("fncls", 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99')
          script.innerHTML = '{"s":"' + s + '", "f":"' + f + '"}'

          document.body.appendChild(script);

          setParamsApplied(true)

          return () => {
              document.body.removeChild(script);
          };
      }
    }, [s, f]);

    useEffect(() => {
        //if payment is piq card, load their script

        if(paramsApplied) {
            const script2 = document.createElement("script");

            script2.type = 'text/javascript'
            script2.src = 'https://c.paypal.com/da/r/fb.js'

            document.body.appendChild(script2);

            return () => {
                document.body.removeChild(script2);
            };
        }
    }, [paramsApplied]);

    return (
      <></>
      // <script type={'application/json'} fncls='fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'>{'{s: "' + s + '", f:"' + f + '"}'}</script>
    )
}

export default FraudNetScript
